<template>
    <div class="content">

        <div class="socials">
            <div class="social">
                
                <img src="../assets/icons/logo-linkedin.svg" alt="" class="social-icon">
                <a href="https://linkedin.com/in/helixwchipofya" target="_blank">linkedin.com/in/helixwchipofya</a>
            </div>
            <div class="social">             
                <img src="../assets/icons/github.svg" alt="" class="social-icon">
                <a href="https://github.com/Helixmw" target="_blank">github.com/Helixmw</a>
            </div>
            <div class="social">             
                <img src="../assets/icons/x-logo.svg"  alt="" class="social-icon">
                <a href="https://x.com/Helix_W" target="_blank">@Helix_W</a>
            </div>
        </div>
    </div>
</template>
<style scoped>
a{
        text-decoration: none;
        color:black;
    }

    .social-icon{
        margin-right: 0.4rem;
        height:1.7rem;
    }

    .social{
        display: flex;
        align-items: center;
        margin-bottom: 1rem;
    }

    .content{
        display: flex;
        
    }
</style>